const OperationsData = [
    {
    id: 1,
    department: 'Collection Development & Technical Services Department (CDTSD)',
    desc: 'The Department comprises of four Divisions namely',
    list1: 'Selection and acquisition',
    list2: 'Cataloging and Classification',
    list3: 'Gifts and Exchanges',
    list4: 'Preservation and Conservation',
    link: 'https://www.cdtsd.org/',
},
{
    id: 2,
    department: 'Legal Deposit Department',
    desc: 'The Department comprises of four Divisions namely',
    list1: 'Legal Deposit',
    list2: 'National bibliography of Nigeria',
    list3: 'Online union catalogue',
    list4: 'Receipts and documentation',
    link: 'https://www.cdtsd.org/',
},
{
    id: 3,
    department: 'International Standards',
    desc: "It's core functions include",
    list1: 'To administer and manage international standards numbers for monographs, Serials and musical work- ISSN, ISBN, ISMN as the National Agency',
    list2: 'To introduce international and National standards methods and norms for book processing through the organization of seminars and workshops',
    link: 'https://www.cdtsd.org/',
},

{
    id: 4,
    department: 'Planning, Research And Statistics',
    desc: "The department comprises three division headed by a Director.Each division headed by a Deputy Director and is made up of Sections and units headed by the most Senior Officers. Its Core functions Include:",
    list1: 'To administer and manage international standards numbers for monographs, Serials and musical work- ISSN, ISBN, ISMN as the National Agency',
    list2: 'To introduce international and National standards methods and norms for book processing through the organization of seminars and workshops',
    link: 'https://www.cdtsd.org/',
},

]

export { OperationsData }